module.exports = __webpack_public_path__ + "static/img/5.ca532cb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/2/sp/5.png
// module id = lWaT
// module chunks = 0